export const asianArabicRegex = /[\u0600-\u06FF\u0750-\u077F\u0780-\u07BF\uFB50-\uFDFF\uFE70-\uFEFF\u4E00-\u9FFF\uAC00-\uD7AF\u3040-\u309f\u30a0-\u30ff\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff]+/gu;
// Находит символы арабского, китайского, японского, корейского алфавита
